module.exports = __webpack_public_path__ + "static/img/t1.3cc5ba68.png";